export default __webpack_public_path__ + "static/media/manage-icon.2a81a0f7.svg";